import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'antd';
import Card from '../CardJob';
import styles from './styles.less';

const CardList = ({ data }) => (
  <div className={styles.container}>
    <Row className={styles.row} type="flex" gutter={20}>
      {data.map(item => (
        <Col xs={14} sm={10} md={8} lg={6} key={item.id}>
          <Card data={item} />
        </Col>
      ))}
    </Row>
  </div>
);

CardList.propTypes = {
  data: PropTypes.array,
};

CardList.defaultProps = {
  data: [],
};

export default CardList;
